import { motion } from "framer-motion";
import { Save, CodeXml } from "lucide-react";
import { useI18n } from "@/lib/i18n";

interface PreviewActionButtonsProps {
  handleSave: () => void;
  handleOverwrite: () => void;
  stripFormatting: () => void;
  hasSaveable: boolean;
  hasTextContent: boolean;
  hasId: boolean;
}

export function PreviewActionButtons({
  handleSave,
  handleOverwrite,
  stripFormatting,
  hasSaveable,
  hasTextContent,
  hasId,
}: PreviewActionButtonsProps) {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-start gap-2 p-2 shrink-0 pt-0">
      {/* 저장 버튼 */}
      <motion.button
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        onClick={handleSave}
        disabled={!hasSaveable}
        data-testid="preview-save-button"
        className="glass-panel h-10 w-[7.5rem] rounded-xl px-3 inline-flex items-center justify-center gap-2 text-sm font-medium text-primary hover:text-accent-foreground disabled:opacity-30 disabled:cursor-not-allowed"
      >
        <Save className="w-4 h-4" />
        <span>{t('preview.save')}</span>
      </motion.button>

      {/* 덮어쓰기 버튼 */}
      {hasTextContent && (
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={handleOverwrite}
          disabled={!hasId}
          data-testid="preview-overwrite-button"
          className="glass-panel h-10 w-[7.5rem] rounded-xl px-3 inline-flex items-center justify-center gap-2 text-sm font-medium text-primary hover:text-accent-foreground disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <CodeXml className="w-4 h-4" />
          <span>{t('preview.overwrite')}</span>
        </motion.button>
      )}

      {/* 텍스트만 버튼 */}
      {hasTextContent && (
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={stripFormatting}
          disabled={!hasTextContent}
          className="glass-panel h-10 w-[7.5rem] rounded-xl px-3 inline-flex items-center justify-center gap-2 text-sm font-medium text-muted-foreground hover:text-accent-foreground disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <div className="relative inline-flex items-center justify-center w-4 h-4">
            <CodeXml className="w-4 h-4" />
            <div className="absolute w-5 h-0.5 bg-destructive rotate-45" />
          </div>
          <span>{t('preview.plain_text') || '텍스트만'}</span>
        </motion.button>
      )}
    </div>
  );
}
